export const desktopLevelMenuHelper = () => {
   
    const mediaQuery = window.matchMedia(`(min-width: 992px)`);
    if(!mediaQuery.matches) return;

    const setupPortalForLevel = (triggerSelector, portalClass, getPortalFromItem, getChildPortal) => {
        const items = document.querySelectorAll(triggerSelector);

        items.forEach(item => {
            const submenu = item.querySelector(':scope > .sub-menu');
            if (!submenu) return;

            const allItems = Array.from(submenu.children);
            if (allItems.length > 0) {
                const visibleItems = allItems.filter(li => !li.classList.contains('--hide-from-menu-mobile'));
                if (visibleItems.length === 0) return;
            }

            if (!item.id) item.id = 'menu-item-generated-' + Math.random().toString(36).substr(2, 9);

            const portal = getPortalFromItem(item);
            if (!portal || !portal.classList.contains(portalClass)) return;

            const childPortal = getChildPortal ? getChildPortal(item) : null;

            const parentUl = item.parentElement;
            let leaveTimer;

            const moveMenuToPortal = () => {
                clearTimeout(leaveTimer);

                if (portal && parentUl) {
                    portal.style.minHeight = `${parentUl.offsetHeight}px`;
                }

                if (portal.dataset.activeItem === item.id) return;

                if (portal.dataset.activeItem) {
                    const activeId = portal.dataset.activeItem;
                    const activeItem = document.getElementById(activeId);
                    const activeContent = portal.querySelector('.sub-menu'); 
                    
                    if (activeItem && activeContent) {
                        activeItem.appendChild(activeContent);
                        activeItem.classList.remove('is-active');
                    }
                }

                portal.appendChild(submenu);
                portal.dataset.activeItem = item.id;
                portal.dataset.triggerItemId = item.id; // Track which item opened this portal
                item.classList.add('is-active');

				// Reset scroll position
                portal.scrollTop = 0;
                
                requestAnimationFrame(() => portal.classList.add('has-content'));
            };

            const closePortal = () => {
                if (portal.dataset.activeItem === item.id) {
                    item.appendChild(submenu);
                    item.classList.remove('is-active');
                    portal.classList.remove('has-content');
                    portal.dataset.activeItem = '';
                    portal.dataset.triggerItemId = '';
                    portal.style.minHeight = '';
                    
                    // Also close child portal if exists
                    if (childPortal && childPortal.classList.contains('has-content')) {
                        const childActiveId = childPortal.dataset.activeItem;
                        if (childActiveId) {
                            const childActiveItem = document.getElementById(childActiveId);
                            const childActiveContent = childPortal.querySelector('.sub-menu');
                            if (childActiveItem && childActiveContent) {
                                childActiveItem.appendChild(childActiveContent);
                                childActiveItem.classList.remove('is-active');
                            }
                        }
                        childPortal.classList.remove('has-content');
                        childPortal.dataset.activeItem = '';
                        childPortal.dataset.triggerItemId = '';
                        childPortal.style.minHeight = '';
                    }
                }
            };

            const scheduledClose = (e) => {
                let delay = 500;

                if (e && e.relatedTarget) {
                    const target = e.relatedTarget;
                    const withinPortal = portal && (portal.contains(target) || portal === target);
                    const withinList = parentUl && (parentUl.contains(target) || parentUl === target);
                    const withinChildPortal = childPortal && (childPortal.contains(target) || childPortal === target);

                    if (!withinPortal && !withinList && !withinChildPortal) {
                        delay = 100;
                    } else if (withinChildPortal) {
                        // Don't close if moving to child portal
                        return;
                    }
                }

                clearTimeout(leaveTimer);
                leaveTimer = setTimeout(() => {
                    const activeElement = document.activeElement;
                    if (item.contains(activeElement) || portal.contains(activeElement)) return;
                    
                    // Check if focus is within child portal
                    if (childPortal && (childPortal.contains(activeElement) || childPortal === activeElement)) return;
                    
                    // Don't close if child portal is active
                    if (childPortal && childPortal.classList.contains('has-content')) return;

                    closePortal();
                }, delay);
            };

            const getFocusables = (el) => {
                return Array.from(el.querySelectorAll('a[href], button:not([disabled]), input, textarea, select, details, [tabindex]:not([tabindex="-1"])'));
            };

            item.addEventListener('mouseenter', moveMenuToPortal);
            item.addEventListener('mouseleave', scheduledClose);
            item.addEventListener('focusin', moveMenuToPortal);
            item.addEventListener('focusout', scheduledClose);
            
            submenu.addEventListener('focusout', scheduledClose);

            if (parentUl) {
                parentUl.addEventListener('mouseleave', scheduledClose);
            }

            portal.addEventListener('mouseenter', () => clearTimeout(leaveTimer));
            portal.addEventListener('focusin', () => clearTimeout(leaveTimer));
            
            portal.addEventListener('mouseleave', (e) => {
                if (portal.dataset.activeItem === item.id) scheduledClose(e);
            });

            portal.addEventListener('focusout', (e) => {
                if (portal.dataset.activeItem === item.id) scheduledClose(e);
            });

            // Keep parent portal open when child portal is active
            if (childPortal) {
                childPortal.addEventListener('mouseenter', () => clearTimeout(leaveTimer));
                childPortal.addEventListener('focusin', () => clearTimeout(leaveTimer));
                
                // Close parent portal when leaving child portal
                childPortal.addEventListener('mouseleave', (e) => {
                    if (e.relatedTarget) {
                        const target = e.relatedTarget;
                        const withinPortal = portal && (portal.contains(target) || portal === target);
                        const withinList = parentUl && (parentUl.contains(target) || parentUl === target);
                        const withinItem = item.contains(target);
                        
                        if (!withinPortal && !withinList && !withinItem) {
                            scheduledClose(e);
                        }
                    }
                });

                childPortal.addEventListener('focusout', (e) => {
                    // Close parent when tabbing out of child portal
                    scheduledClose(e);
                });

                // Handle tab navigation from child portal
                childPortal.addEventListener('keydown', (e) => {
                    if (e.key === 'Tab') {
                        const focusables = getFocusables(childPortal);
                        if (focusables.length === 0) return;

                        const first = focusables[0];
                        const last = focusables[focusables.length - 1];

                        // Shift+Tab on first element - go back to trigger item in parent portal
                        if (e.shiftKey && document.activeElement === first) {
                            e.preventDefault();
                            const triggerItemId = childPortal.dataset.triggerItemId;
                            if (triggerItemId) {
                                const triggerItem = document.getElementById(triggerItemId);
                                const triggerLink = triggerItem?.querySelector(':scope > a');
                                if (triggerLink) triggerLink.focus();
                            }
                        }
                        // Tab on last element - find next sibling of trigger or exit portal
                        else if (!e.shiftKey && document.activeElement === last) {
                            e.preventDefault();
                            const triggerItemId = childPortal.dataset.triggerItemId;
                            if (triggerItemId) {
                                const triggerItem = document.getElementById(triggerItemId);
                                const nextSibling = triggerItem?.nextElementSibling;
                                
                                if (nextSibling) {
                                    const nextLink = nextSibling.querySelector(':scope > a');
                                    if (nextLink) nextLink.focus();
                                } else {
                                    // Find the item that opened the parent portal
                                    const parentPortalTriggerId = portal.dataset.triggerItemId;
                                    if (parentPortalTriggerId) {
                                        const parentTrigger = document.getElementById(parentPortalTriggerId);
                                        const parentNextSibling = parentTrigger?.nextElementSibling;
                                        
                                        if (parentNextSibling) {
                                            const parentNextLink = parentNextSibling.querySelector(':scope > a');
                                            if (parentNextLink) parentNextLink.focus();
                                        } else {
                                            // Move to next 0-level item
                                            const level0Parent = parentTrigger.closest('.header__nav > ul > li');
                                            if (level0Parent) {
                                                const level0NextSibling = level0Parent.nextElementSibling;
                                                if (level0NextSibling) {
                                                    const level0NextLink = level0NextSibling.querySelector(':scope > a');
                                                    if (level0NextLink) level0NextLink.focus();
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            }

            item.addEventListener('keydown', (e) => {
                if (e.key === 'Tab' && !e.shiftKey && portal.dataset.activeItem === item.id) {
                    const focusables = getFocusables(submenu);
                    if (focusables.length > 0) {
                        e.preventDefault();
                        focusables[0].focus();
                    }
                } 
                else if (e.key === 'Tab' && e.shiftKey && !item.previousElementSibling) {
                    e.preventDefault();
                    
                    // Check if we're in submenu-portal-base (2nd level)
                    if (portal.classList.contains('submenu-portal-base')) {
                        // Go back to the 0-level item that contains this portal
                        const level0Parent = portal.closest('.header__nav > ul > li');
                        if (level0Parent) {
                            const level0Link = level0Parent.querySelector(':scope > a');
                            if (level0Link) {
                                level0Link.focus();
                                // Close the portal after navigating away
                                setTimeout(() => closePortal(), 0);
                            }
                        }
                    } else {
                        // For other portals, go back to the trigger that opened this portal
                        const parentTriggerId = portal.dataset.triggerItemId;
                        if (parentTriggerId) {
                            const parentTrigger = document.getElementById(parentTriggerId);
                            const parentLink = parentTrigger?.querySelector(':scope > a');
                            if (parentLink) parentLink.focus();
                        }
                    }
                }
            });


            submenu.addEventListener('keydown', (e) => {
                if (e.key === 'Tab') {
                    const focusables = getFocusables(submenu);
                    const first = focusables[0];
                    const last = focusables[focusables.length - 1];

                    if (e.shiftKey && document.activeElement === first) {
                        e.preventDefault();
                        const triggerLink = item.querySelector(':scope > a');
                        if (triggerLink) triggerLink.focus();
                    }
                    else if (!e.shiftKey && document.activeElement === last) {
                        e.preventDefault();
                        const nextLi = item.nextElementSibling;
                        
                        if (nextLi) {
                            // There's a next sibling in the current portal
                            const nextLink = nextLi.querySelector(':scope > a');
                            if (nextLink) nextLink.focus();
                        } else {
                            // No next sibling - we need to navigate up
                            const parentTriggerId = portal.dataset.triggerItemId;
                            if (parentTriggerId) {
                                const parentTrigger = document.getElementById(parentTriggerId);
                                
                                // Check if we're in submenu-portal (3rd level)
                                if (portal.classList.contains('submenu-portal')) {
                                    // We're in 3rd level, check for next 2nd-level item
                                    const parentNextSibling = parentTrigger?.nextElementSibling;
                                    
                                    if (parentNextSibling) {
                                        // There's a next 2nd-level item
                                        const parentNextLink = parentNextSibling.querySelector(':scope > a');
                                        if (parentNextLink) parentNextLink.focus();
                                    } else {
                                        // No next 2nd-level item, find the submenu-portal-base trigger
                                        const level0Parent = parentTrigger.closest('.header__nav > ul > li');
                                        const portalBase = level0Parent?.querySelector('.submenu-portal-base');
                                        const portalBaseTriggerId = portalBase?.dataset.triggerItemId;
                                        
                                        if (portalBaseTriggerId) {
                                            const portalBaseTrigger = document.getElementById(portalBaseTriggerId);
                                            const portalBaseTriggerNext = portalBaseTrigger?.nextElementSibling;
                                            
                                            if (portalBaseTriggerNext) {
                                                // There's a next 1st-level item
                                                const nextLink = portalBaseTriggerNext.querySelector(':scope > a');
                                                if (nextLink) nextLink.focus();
                                            } else {
                                                // No next 1st-level item, move to next 0-level item
                                                const level0NextSibling = level0Parent?.nextElementSibling;
                                                if (level0NextSibling) {
                                                    const level0NextLink = level0NextSibling.querySelector(':scope > a');
                                                    if (level0NextLink) level0NextLink.focus();
                                                }
                                            }
                                        }
                                    }
                                } else if (portal.classList.contains('submenu-portal-base')) {
                                    // We're in 2nd level, check for next 1st-level item
                                    const parentNextSibling = parentTrigger?.nextElementSibling;
                                    
                                    if (parentNextSibling) {
                                        // There's a next 1st-level item
                                        const parentNextLink = parentNextSibling.querySelector(':scope > a');
                                        if (parentNextLink) parentNextLink.focus();
                                    } else {
                                        // No next 1st-level item, move to next 0-level item
                                        const level0Parent = parentTrigger.closest('.header__nav > ul > li');
                                        if (level0Parent) {
                                            const level0NextSibling = level0Parent.nextElementSibling;
                                            
                                            if (level0NextSibling) {
                                                const level0NextLink = level0NextSibling.querySelector(':scope > a');
                                                if (level0NextLink) level0NextLink.focus();
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            });
        });
    };

    // Setup for 2nd Level Menu (children of 1st level items)
    setupPortalForLevel(
        '.header__nav > ul > li.menu-item-has-children > .sub-menu > li.menu-item-has-children', 
        'submenu-portal-base',
        (item) => {
            const level0Parent = item.closest('.header__nav > ul > li');
            return level0Parent ? level0Parent.querySelector('.submenu-portal-base') : null;
        },
        (item) => {
            // Get child portal (.submenu-portal) for keeping parent open
            const level0Parent = item.closest('.header__nav > ul > li');
            return level0Parent ? level0Parent.querySelector('.submenu-portal') : null;
        }
    );

    // Setup for 3rd Level Menu (children of 2nd level items)
    setupPortalForLevel(
        '.header__nav > ul > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children', 
        'submenu-portal',
        (item) => {
            const level0Parent = item.closest('.header__nav > ul > li');
            return level0Parent ? level0Parent.querySelector('.submenu-portal') : null;
        },
        null // No child portal for 3rd level
    );
};